import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList as userFetchList } from "@/api/system/user/user";
import { fetchList } from "@/api/PMS/communityPartyBuilding/registrationInformation";
import { fetchList as fetchTypeList } from "@/api/PMS/communityPartyBuilding/activityType";
import waves from "@/directive/waves"; // 水波纹指令

import { formatJson } from "@/utils/index";
export default {
  name: "ComplexTable",
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      userOptions: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        auditStatus: "2",
        activityId: 3
      },
      id: -1,
      dates: [],
      dates2: [],
      options: [],
      multipleSelection: []
    };
  },
  created: function created() {
    // 获取路由的配置
    var appType = this.$route.query.appType;

    if (appType !== undefined) {
      this.listQuery.appType = parseInt(appType);
    }

    this.getUser();
    this.getList();
    this.getTypeOption();
  },
  methods: {
    getUser: function getUser() {
      var _this = this;

      userFetchList({}).then(function (res) {
        _this.userOptions = res.data.data;
      });
    },
    getList: function getList() {
      var _this2 = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      if (this.dates2 !== null && this.dates2.length > 0) {
        this.listQuery.registrationBeginDate = this.dates2[0];
        this.listQuery.registrationEndDate = this.dates2[1];
      } else {
        this.listQuery.registrationBeginDate = "";
        this.listQuery.registrationEndDate = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this2.list = response.data.data;
        _this2.total = response.data.total;
        _this2.listLoading = false;
      });
    },
    getTypeOption: function getTypeOption() {
      var _this3 = this;

      fetchTypeList({
        page: 1,
        appType: this.listQuery.appType
      }).then(function (res) {
        _this3.options = res.data.data;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    handleExport: function handleExport() {
      var _this4 = this;

      this.exLists = [];
      this.$confirm("你确定要导出职工活动报名情况吗, 是否继续?", "提示").then(function () {
        var beginDate = "";
        var endDate = "";

        if (_this4.dates !== null && _this4.dates.length > 0) {
          beginDate = _this4.dates[0];
          endDate = _this4.dates[1];
        }

        var beginDate2 = "";
        var endDate2 = "";

        if (_this4.dates2 !== null && _this4.dates2.length > 0) {
          beginDate2 = _this4.dates2[0];
          endDate2 = _this4.dates2[1];
        }

        fetchList({
          activityTitle: _this4.listQuery.activityTitle,
          activityId: _this4.listQuery.activityId,
          itemName: _this4.listQuery.itemName,
          coachId: _this4.listQuery.coachId,
          endDate: endDate,
          beginDate: beginDate,
          registrationEndDate: endDate2,
          registrationBeginDate: beginDate2,
          auditStatus: _this4.listQuery.auditStatus
        }).then(function (response) {
          var list = response.data.data;

          if (list !== null && list.length > 0) {
            list.forEach(function (element) {
              switch (element.auditStatus) {
                case 1:
                  element.auditStatus = "未审核";
                  break;

                case 2:
                  element.auditStatus = "审核通过";
                  break;

                case 3:
                  element.auditStatus = "审核不通过";
                  break;

                default:
                  break;
              }

              switch (element.isCancel) {
                case 0:
                  element.isCancel = "未取消";
                  break;

                case 1:
                  element.isCancel = "已取消";
                  break;

                default:
                  break;
              }
            });
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["项目内容", "项目类型", "报名内容", "活动开始时间", "活动结束时间", "微信昵称", "报名时间", "学员姓名", "联系方式", "证件号码", "教练", "审核状态", "是否取消报名"];
              var fileterVal = ["activityTitle", "activityTypeName", "itemName", "activityBeginDate", "activityEndDate", "nickName", "enrollmentTime", "studentName", "tel", "idCard", "coachName", "auditStatus", "isCancel"];
              var data = formatJson(fileterVal, list);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: "职工活动报名情况",
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this4.Alert({
              alertType: "error",
              message: "暂无数据，无法导出！"
            });
          }
        });
      });
    }
  }
};